module.exports = __webpack_public_path__ + "img/case13.148e1f93.jpg";